var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHkHongKong(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_19177)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.28959 45.12H62.165V0H-2.28959V45.12Z",
    fill: "#BA0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8544 21.8373C30.8544 21.8373 35.4016 19.881 34.7495 14.805C34.1238 12.3639 33.0046 10.6983 30.9866 9.79064C30.0348 9.49983 29.0654 9.36764 28.0784 9.28833C28.3428 9.53508 28.5543 9.78183 28.6689 10.0815C28.8804 10.6455 28.7217 11.1742 28.4309 11.7118C28.0696 12.3286 27.8493 12.9631 27.7788 13.7915C27.7126 14.356 27.7967 14.928 28.0226 15.4495C28.2486 15.971 28.6083 16.4236 29.0654 16.7613C29.647 17.2108 30.3344 17.3694 30.8984 17.8805C31.3391 18.3035 31.6034 18.7353 31.6916 19.4756C31.7092 20.8944 31.3302 21.0971 30.8544 21.8373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6343 14.4702V14.4967H31.8193V14.4702H31.6343Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6417 17.809C32.6275 19.1405 32.2275 20.4841 31.3742 21.2392L31.4968 21.3778C32.406 20.5732 32.8123 19.1672 32.8267 17.811C32.834 17.1306 32.7429 16.4568 32.5637 15.8685C32.3849 15.2813 32.1164 14.773 31.7644 14.4302L31.6353 14.5628C31.9574 14.8765 32.2133 15.353 32.3867 15.9224C32.5598 16.4907 32.6488 17.1455 32.6417 17.809Z",
    fill: "#BA0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6162 13.6154L30.3254 14.1001L30.8541 13.8797L31.2683 14.3204L31.1978 13.7476L31.7266 13.5272L31.1538 13.3951L31.0832 12.8311L30.7924 13.3157L30.2108 13.1836",
    fill: "#BA0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4668 21.5024C30.4668 21.5024 29.938 16.5762 24.8885 15.7126C22.3681 15.6069 20.447 16.1797 18.9841 17.854C18.4289 18.6736 18.0235 19.5637 17.6622 20.4802C17.9707 20.3039 18.2615 20.1717 18.5964 20.1541C19.1868 20.11 19.6539 20.4185 20.0769 20.8503C20.5708 21.3971 21.1867 21.8198 21.8746 22.084C22.3943 22.3138 22.9655 22.4022 23.5303 22.3403C24.0951 22.2784 24.6336 22.0684 25.0912 21.7315C25.6904 21.2997 26.0429 20.6917 26.695 20.3039C27.225 19.9889 27.8532 19.8821 28.4575 20.0043C29.8235 20.4097 29.894 20.8327 30.4668 21.5024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6806 18.6165H23.707V18.4314H23.6806V18.6165Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1393 18.6143C28.4086 19.0181 29.5784 19.7947 30.0564 20.8361L30.2246 20.7589C29.7156 19.6501 28.4885 18.8493 27.1954 18.4379C26.5468 18.2316 25.8762 18.1213 25.2618 18.1199C24.6484 18.1185 24.0845 18.2256 23.6543 18.4603L23.7429 18.6227C24.1366 18.408 24.6666 18.3036 25.2613 18.3049C25.855 18.3063 26.5068 18.413 27.1393 18.6143Z",
    fill: "#BA0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5348 19.3259L22.9138 19.7401L22.8609 19.1673L23.3896 18.9029L22.8345 18.8148L22.7816 18.2244L22.482 18.7531L21.918 18.6474L22.2969 19.0616L22.0061 19.5903",
    fill: "#BA0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1318 21.855C30.1318 21.855 25.285 20.7975 22.8703 25.3183C21.9626 27.6712 21.901 29.6717 23.0202 31.584C23.6194 32.3771 24.342 33.038 25.0911 33.6814C25.0206 33.3289 24.9941 33.0116 25.0823 32.6944C25.2233 32.1127 25.6639 31.769 26.2103 31.5047C26.8882 31.2082 27.4862 30.7552 27.9552 30.1828C28.3353 29.7628 28.5982 29.2502 28.7174 28.6963C28.8365 28.1425 28.8076 27.5671 28.6337 27.0279C28.4222 26.3229 27.9551 25.7942 27.7965 25.0539C27.6646 24.4529 27.7621 23.8243 28.0697 23.2914C28.8893 22.1282 29.3123 22.1899 30.1318 21.855Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1611 27.3276L25.1435 27.3453L25.1611 27.3276Z",
    fill: "#BA0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2089 27.4107L25.2266 27.3931L25.0957 27.2622L25.0781 27.2798L25.2089 27.4107Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3323 24.0972C27.117 23.0211 28.2222 22.1588 29.3574 22.035L29.3374 21.8511C28.1284 21.9829 26.9821 22.8919 26.1827 23.9881C25.7818 24.538 25.4646 25.1395 25.2681 25.723C25.0719 26.3054 24.994 26.8759 25.0791 27.3611L25.2614 27.3291C25.1835 26.8846 25.2532 26.3469 25.4434 25.7821C25.6333 25.2183 25.9412 24.6334 26.3323 24.0972Z",
    fill: "#BA0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5494 28.6935L26.0693 28.4643L25.4965 28.3321L25.426 27.7417L25.1528 28.244L24.58 28.1118L24.9766 28.5525L24.7122 29.0548L25.2233 28.8256L25.6199 29.2751",
    fill: "#BA0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2372 22.3572C30.2372 22.3572 27.8667 26.7106 31.515 30.2885C33.5243 31.8218 35.4278 32.4475 37.578 31.91C38.5034 31.5575 39.3405 31.0551 40.1777 30.5088C39.8252 30.4823 39.4992 30.4206 39.2172 30.2444C38.706 29.9448 38.5034 29.4248 38.3976 28.8344C38.3059 28.0981 38.04 27.3942 37.6221 26.7811C37.3264 26.2973 36.9084 25.9 36.4102 25.6292C35.912 25.3585 35.3513 25.2238 34.7845 25.2389C34.0442 25.2477 33.4097 25.5561 32.6519 25.5033C32.0438 25.424 31.5679 25.2565 31.0304 24.7278C30.1491 23.6262 30.3254 23.2296 30.2372 22.3484V22.3572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0976 28.667L34.1064 28.6846L34.0976 28.667Z",
    fill: "#BA0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1885 28.6434L34.1797 28.6257L34.0141 28.7085L34.023 28.7261L34.1885 28.6434Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3216 26.6301C30.5097 25.5738 29.9955 24.2674 30.2046 23.1409L30.0227 23.1072C29.7999 24.3072 30.3477 25.6666 31.1749 26.7429C31.5899 27.2828 32.0785 27.7562 32.584 28.1075C33.0885 28.4582 33.615 28.6909 34.105 28.7415L34.124 28.5575C33.6755 28.5111 33.1787 28.2955 32.6896 27.9555C32.2014 27.6162 31.7262 27.1565 31.3216 26.6301Z",
    fill: "#BA0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5161 28.6758L35.4367 28.1118L35.1459 28.6141L34.5643 28.526L34.9697 28.9314L34.6789 29.4337L35.2164 29.1781L35.6218 29.5835L35.5513 29.0195L36.0889 28.7639",
    fill: "#BA0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7752 22.2603C30.7752 22.2603 34.0887 25.944 38.6888 23.7056C40.8038 22.322 42.02 20.727 42.2227 18.5238C42.1962 17.528 42.0112 16.5763 41.7732 15.6157C41.6234 15.933 41.456 16.215 41.2004 16.4265C40.751 16.8054 40.187 16.823 39.5877 16.7261C38.8684 16.5686 38.1218 16.5867 37.411 16.779C36.8545 16.8961 36.3388 17.1584 35.9163 17.5391C35.4938 17.9198 35.1795 18.4055 35.0052 18.9468C34.7673 19.643 34.8466 20.348 34.5382 21.0442C34.2738 21.5906 33.9565 21.9783 33.278 22.3132C31.9385 22.7803 31.63 22.4807 30.7752 22.2692V22.2603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0097 20.7271L38.0273 20.7183L38.0097 20.7271Z",
    fill: "#BA0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9866 20.6355L37.969 20.6443L38.0517 20.8098L38.0693 20.801L37.9866 20.6355Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1658 22.6592C33.8998 23.074 32.4984 23.1264 31.5086 22.5589L31.4165 22.7195C32.4712 23.3241 33.9338 23.2576 35.2235 22.8351C35.8704 22.6232 36.4794 22.32 36.9792 21.9609C37.4781 21.6024 37.8733 21.1843 38.085 20.7403L37.9179 20.6606C37.7242 21.067 37.3549 21.463 36.8712 21.8106C36.3884 22.1576 35.7967 22.4526 35.1658 22.6592Z",
    fill: "#BA0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4859 19.3876L37.9307 19.273L38.3096 19.7137L38.0365 20.2336L38.5476 19.9869L38.9265 20.4275L38.8648 19.8282L39.3848 19.5815L38.8296 19.4669L38.7679 18.8677",
    fill: "#BA0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_19177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHkHongKong);
export default __webpack_public_path__ + "static/media/hk Hong Kong.7d80ace1d86508e746e207c53766825e.svg";
export { ForwardRef as ReactComponent };